import React from "react";
import Container from "../../components/UI/Container";
import { Static, TermsList } from "./Styles";
import { Link } from "react-router-dom";

const s = `
<h4>
§ 1 DEFINITIONS
</h4>
<ol>

<li>TaC — Terms and Conditions for the TdC Solutions services.

<li>TdC — TdC Solutions OÜ with its seat in Kanarbiku 2, Soinaste küla, Tartumaa, Estonia.

<li>Client — User of the debt collection service.

<li>Parties — TdC and the Client jointly.

<li>Services — services provided by TdC for the Client.

<li>Contract — contract for Services provided to the Client, made by the Parties through the Client’s acceptance of the Terms and Conditions.
</li>
</ol>
<h4>
§ 2 GENERAL
</h4>
<ol>

<li>The Client accepts these Terms and Conditions by clicking the ‘Accept TaC’ button below the contents of the TaC while registering the claim at website <a href="http://tdc-solutions.eu">tdc-solutions.eu</a>. 

<li>In accepting the Terms and Conditions the Client represents that the Client has read the contents and accepts them fully (without reservations).

<li>In order to be able to gain access to TdC Services, the Client must first sign the Contract and pay the fee of claim examination according to the Price List.

<li>Communication from TdC to the Client shall be directly through <a href="http://tdc-solutions.eu">tdc-solutions.eu</a> website, by e-mail, by phone or any other way. 
</li>
</ol>
<h4>
§ 3 TERMS OF USE OF THE SERVICES
</h4>
<ol>

<li>Upon TdC decision of positive verification of the Client’s data on terms set out in § 4, the debt collection will be in process according to the signed Contract.<br>
</li>
</ol>
<h4>
§ 4 VERIFICATION OF CLIENT DATA
</h4>
<ol>

<li>After the Client registers the claim at website <a href="http://tdc-solutions.eu">tdc-solutions.eu</a>, TdC will carry out a procedure to verify the Client’s data.

<li>The purpose of verifying the Client’s data is to establish the probable existence of the Client’s enterprise on the basis of publicly available information (including without limitation public registers).

<li>For the purposes of positive verification of the Client’s data, the Client must, if so required by TdC, send to TdC by e-mail or letter, without delay, such copies of documents as TdC may specify.

<li>TdC reserves the right to contact the Client by telephone in order to verify the Client’s contact data.

<li>On the basis of the TaC and internal verification procedures, subject to the protection of the interests of TdC and its other Clients, TdC will make the decision about either the positive or the negative outcome of the verification of the Client’s data. TdC will notify the Client of the outcome without delay.
</li>
</ol>
<h4>
§ 5 ENTERING INTO A RECOVERY CONTRACT
</h4>
<ol>

<li>Upon meeting the conditions set out in § 2–3 and positive verification of the Client’s data and identity by TdC, the Client may enter into a Recovery Contract with TdC.

<li>To enter into a Recovery Contract the Client sign the Contract and return it to TdC by e-mail.<br>
</li>
</ol>
<h4>
§ 6 RIGHTS AND OBLIGATIONS
</h4>
<ol>

<li>TdC agrees to provide the Services with due diligence according to TdC’s knowledge, ability and technical protections, as well as provisions of These Terms and Conditions.

<li>The Client is prohibited from submitting unlawful, offensive or vulgar content. The Client agrees to use TdC Services solely for purposes consistent with the law.

<li>The Client is not entitled to use the Services on behalf of a third party.

<li>The Client represents that all data provided by the Client to TdC and all document scans entered or confirmed by the Client are conscientious, up-to-date and accurate and provided by the Client in a wholly voluntary manner.
</li>
</ol>
<h4>
§ 7 PERSONAL DATA PROCESSING
</h4>
<ol>

<li>The controller of any personal data submitted by the Client is TdC.

<li>The Data Controller is TdC Solutions OÜ (hereinafter ‘TdC’) with its seat in Kanarbiku 2, Soinaste küla, Tartumaa, Estonia.

<li>Data may be processed by TdC:<br>a. for the purposes of preparing the formation of a contract with the Client — on the basis of Article 6(1)(b) GDPR, i.e. whenever necessary in order to take an action requested by the Client prior to entering into the contract (to this end, TdC will store the Data until such actions are completed or until the Contract is made);<br>b. for the purposes of providing Services or performing a contract made with the Client — on the basis of Article 6(1)(b) GDPR, i.e. whenever necessary in order to provide Services or perform a contract made with the Client (to this end, TdC will store the Data for the duration of the Contract and settlements upon its completion, though no later than the statute of limitations on claims arising thereunder);<br>c. for the purpose of determination and enforcement of TdC’s claims or defence against claims — on the basis of Article 6(1)(f) GDPR, i.e. whenever the legal basis for processing is TdC’s legitimate interest consisting in the defence of TdC’s rights (TdC will store the Data until the statute of limitations on TdC’s claims under the contract — the storage duration is defined by the provisions of the law, including without limitation the provisions of the Civil Code);<br>d. for analytical and statistical purposes — on the basis of Article 6(1)(f) GDPR, i.e. whenever the legal basis for processing is TdC’s legitimate interest — improvement of the quality of services provided and adaptation of such services to clients’ needs (TdC will store the Data for 3 years following the end of the contract or of the event triggering the need for such processing);<br>e. for direct-marketing purposes — on the basis of Article 6(1)(f) GDPR, i.e. whenever the legal basis for processing is TdC’s legitimate interest consisting in the controller’s right, expressed in GDPR recital 47, to process personal data for direct-marketing purposes (TdC will store the data until the data subject’s effective objection, if any);<br>f. for the purposes of compliance with obligations imposed by the provisions of the law (including without limitation accounting, bookkeeping, taxation) — pursuant to Article 6(1)(c) GDPR. (TdC will store the data for the duration required by the provisions of the law, e.g. provisions requiring the controller to keep tax books until the statute of limitations on the tax obligation).<br>

<li>The provision of Data for the aforesaid purposes is voluntary, although not providing the Data may prevent the formation or performance of a Contract between the Client and TdC.<br>

<li>Data may be entrusted on the basis of a separate Contract:<br>a. to TdC’s affiliates, i.e. TdC Solutions OÜ;<br>b. TdC contractors and business partners, including without limitation the providers of select services to TdC (bookkeeping, marketing or IT services; e-payment operators — to the extent necessary for the provision of such services).<br>

<li>On such terms and within such limits as provided by applicable provisions of the law, the Client has a right to:<br>a. access the Client’s data and receive copies thereof;<br>b. rectify (correct) the Client’s data;<br>c. delete the Data or restrict the processing;<br>d. object to the processing (including profiling);<br>e. transfer the Data;<br>f. lodge a complaint with the supervisory body;<br>g. withdraw the Client’s consent to the processing of personal Data if such Data is processed on the basis of the Client’s consent (Article 6(1)(f) GDPR).<br>
</li>
</ol>
<h4>
§ 8 COMPLAINTS
</h4>
<ol>

<li>This section sets forth the conditions to be met by a complaint about TdC’s services and the procedure for complaints.

<li>The entity entitled to submit a complaint is the Client.

<li>A complaint may be filed in writing to <a href="mailto:info@tdc-solutions.eu">info@tdc-solutions.eu</a>.

<li>The complaint should include:<br>a. the name and surname (company name) and residence or seat address of the Client, hereinafter the ‘Complainant’;<br>b. the subject-matter of the complaint;<br>c. circumstances justifying the complaint;<br>d. the Complainant’s signature — if in writing.

<li>Where the complaint fails to meet the conditions set out in § 12(1–4), TdC will notify the Complainant that the complaint fails to meet the complaint conditions, which will result in leaving such a complaint without consideration.

<li>TdC will consider any complaint within 14 days of filing. TdC reserves the right to extend the 14-day time-limit for responding to a complaint whenever the response depends on additional technical or legal analysis or translation, of which the Complainant will be notified without delay.

<li>TdC will respond to the complaint:<br>a. in writing, by sending the response to the address of the Complainant’s seat;<br>b. by e-mail, to the e-mail address provided by the Complainant.

<li>TdC reserves the right to leave a complaint unconsidered or decline to respond if:<br>a. response to the complaint will contain information provided in response to the Complainant’s previous complaint;<br>b. the complaint: 
<ul>
 
<li>fails to contain sufficient data to identify the Complainant;
 
<li>fails to contain data enabling a response to be given and sent;
 
<li>fails to be in sufficient form as to be deemed a complaint;
 
<li>fails to contain information about the causes of the complaint, questions, description of issues;
 
<li>contains offensive, disparaging or vulgar contents or contents inciting hatred, racism, xenophobia or conflicts among nations.
</li> 
</ul>

<li>TdC will notify the Complainant of the exercise of the above right without delay.

<li>The Complainant shall bear full responsibility and liability for any contents included in the complaint.<br>
</li>
</ol>
<h4>
§ 9 TERMINATION
</h4>
<ol>

<li>Any party may terminate the Contract in writing, subject to one month’s notice period, with effect as at the end of the month.

<li>With the day of termination the Contract will be terminated. 

<li>Until the day of termination of the Contract TdC retains the right to provide debt-recovery services for all receivables submitted by the Client for recovery prior to the termination of the Contract and to the payment due for such services.

<li>TdC may terminate the Contract with no notice period (i.e. with immediate effect) if the Client does not comply with the conditions specified in the Terms and Conditions or violates the Terms and Conditions, or if any statement made by the Client turns out to be false.
</li>
</ol>
<h4>
§ 10 AMENDMENTS OF THE TERMS OF SERVICE
</h4>
<ol>

<li>These Terms and Conditions are made available to the Client at the website <a href="http://tdc-solutions.eu">tdc-solutions.eu</a>.

<li>TdC reserves the right to modify the Terms and Conditions for important reasons including without limitation:<br>a. changes to the law;<br>b. organisational reasons, including without limitation: 
<ul>
 
<li>modification of the scope of TdC activities, in the form of changes to the profile or to the scope of Services;<br>
 
<li>introduction of new Services or improvements (including as regards the formation and termination of contracts);<br>
 
<li>changes to: TdC’s contact data, name or legal form of organisation;<br>
 
<li>changes at methods of Client verification;<br>
 
<li>changes to the scope of Services provided;<br>
 
<li>other technical changes.<br>
</li> 
</ul>

<li>TdC will notify the Client of contemplated changes to the TaC by e-mail to the Client’s e-mail address, at least 10 days prior to any such changes entering into force, identifying such changes.<br>

<li>Until the day preceding the day of entry into force of the changes to the TaC as specified by TdC the Client may object to the changes or terminate the Contract with effect from the day of notification of the Client of the change, though no later than the day the changes would otherwise begin to apply. Any objection or termination requires written form. In order to keep the deadline for the objection or termination, the objection or termination must be delivered to TdC before the deadline expires. Failure by the Client to object to the changes in the manner and time specified in this provision shall be tantamount with consenting to the changes and to their entry into force at the time specified by TdC. For a Client not having terminated the Contract in the manner and time specified in this provision or objected to TaC changes, the Contract shall expire with the day preceding the day of entry of the changes in force. The Client will not be required to make any payments to TdC due to the termination of the Contract or expiry in the event of the objection referred to in this provision.<br>
</li>
</ol>
<h4>
§ 11 MISCELLANEOUS
</h4>
<ol>

<li>Any disputes arising out of or connected with these Terms and Conditions will be adjudicated by the common court of competent venue by reason of place for TdC’s seat.

<li>For matters not regulated in these Terms and Conditions or the Contract TdC’s applicable law shall apply.

<li>These Terms and Conditions enter into force on 1 February 2024
</li>
</ol>
<p>
TdC Solutions - Transport Debt Collection<br>Kanarbiku 2, Soinaste küla, 61709 Tartumaa, Estonia
</p>
<p>
Phone: +372 55 514 514, <a href="mailto:info@tdc-solutions.eu">info@tdc-solutions.eu</a>, <a href="http://www.tdc-solutions.eu">www.tdc-solutions.eu</a>
</p>
`

const o = {
  __html: s
}

const Terms = () => {
  return (
    <Container gutter="large">
      <Static>
        <h1>TdC Solutions - Terms and Conditions</h1>
        <TermsList>
          <div dangerouslySetInnerHTML={o} />
        </TermsList>
        </Static>
    </Container>
  );
};

export default Terms;